import i18nFactory from '@yandex-int/i18n';
import { get, isNull, isString } from 'lodash';

import { ValidationResultItem } from '../../typings/common';

import * as keyset from './GraphqlErrorHelper.i18n';

const i18n = i18nFactory(keyset);

export const getErrorMessage = (args: ValidationResultItem): string => {
    if (!args.code) {
        return '';
    }

    // TODO: Удалить paramsObject после решения https://github.com/apollographql/apollo-cli/issues/474
    // Тип params на самом деле object | null
    let paramsObject = args.params as object;

    if (isNull(args.params) || isString(args.params)) {
        paramsObject = {};
    }

    // TODO: DIRECT-80615 локализировать все ошибки
    switch (args.code) {
        case 'PhraseDefectIds.String.ILLEGAL_CHARACTERS':
            return i18n('PhraseDefectIds.String.ILLEGAL_CHARACTERS', {
                ...paramsObject
            });

        case 'PhraseDefectIds.String.TOO_LONG_WORD':
            return i18n('PhraseDefectIds.String.TOO_LONG_WORD', {
                ...paramsObject
            });

        case 'PhraseDefectIds.String.TOO_LONG_MINUS_WORD':
            return i18n('PhraseDefectIds.String.TOO_LONG_MINUS_WORD', {
                ...paramsObject
            });

        case 'PhraseDefectIds.String.TOO_MANY_WORDS':
            return i18n('PhraseDefectIds.String.TOO_MANY_WORDS', {
                ...paramsObject
            });

        case 'PhraseDefectIds.Gen.INVALID_EXCLAMATION_MARK':
            return i18n('PhraseDefectIds.Gen.INVALID_EXCLAMATION_MARK');

        case 'PhraseDefectIds.Gen.NO_PLUS_WORDS':
            return i18n('PhraseDefectIds.Gen.NO_PLUS_WORDS');

        case 'PhraseDefectIds.Gen.INVALID_MINUS_MARK':
            return i18n('PhraseDefectIds.Gen.INVALID_MINUS_MARK');

        case 'PhraseDefectIds.Gen.INVALID_PLUS_MARK':
            return i18n('PhraseDefectIds.Gen.INVALID_PLUS_MARK');

        case 'PhraseDefectIds.Gen.BOTH_QUOTES_AND_MINUS_WORDS':
            return i18n('PhraseDefectIds.Gen.BOTH_QUOTES_AND_MINUS_WORDS');

        case 'PhraseDefectIds.Gen.ONLY_STOP_WORDS':
            return i18n('phrase-only-stop-words');

        case 'PhraseDefectIds.String.NOT_SINGLE_MINUS_WORD':
            return i18n('PhraseDefectIds.String.NOT_SINGLE_MINUS_WORD', {
                phrase: get(args, `params.allInvalidSubstrings`, '')
            });
        case 'KeywordDefectIds.Gen.NO_RIGHTS_IN_ARCHIVED_ADGROUP':
            // TODO: DIRECT-80615 value должен быть удален и вместно него должен использоваться params.
            return i18n('KeywordDefectIds.Gen.NO_RIGHTS_IN_ARCHIVED_ADGROUP', {
                validationResultValue: args.value
            });

        case 'KeywordDefectIds.Keyword.MAX_KEYWORDS_PER_AD_GROUP_EXCEEDED':
            return i18n(
                'KeywordDefectIds.Keyword.MAX_KEYWORDS_PER_AD_GROUP_EXCEEDED',
                {
                    ...paramsObject
                }
            );

        case 'CollectionDefectIds.Gen.CANNOT_BE_EMPTY':
            return i18n('CollectionDefectIds.Gen.CANNOT_BE_EMPTY');

        case 'GdExceptions.NO_RIGHTS':
            return i18n('GdExceptions.NO_RIGHTS');

        case 'GdExceptions.ACCESS_DENIED':
            return i18n('GdExceptions.ACCESS_DENIED');

        case 'DefectIds.NO_RIGHTS':
            return i18n('DefectIds.NO_RIGHTS');

        case 'StringDefectIds.CANNOT_BE_EMPTY':
            return i18n('StringDefectIds.CANNOT_BE_EMPTY');

        case 'NumberDefectIds.MUST_BE_NOT_OLDER':
            return i18n('NumberDefectIds.MUST_BE_NOT_OLDER');

        default:
            return i18n('unknown-error');
    }
};

export const getErrorTitle = (args?: ValidationResultItem): string => {
    if (!args) {
        return i18n('unknown-error-title');
    }

    switch (args.code) {
        case 'NumberDefectIds.MUST_BE_NOT_OLDER':
            return i18n('NumberDefectIds.MUST_BE_NOT_OLDER-TITLE');
        default:
            return i18n('unknown-error-title');
    }
};
